import React, { useState } from 'react';
import Modal from '../../components/common/Modal';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { useApi } from '../../hooks/useApi';
import { editLedgerEntry } from '../../lib/api/ledger';
import { useAuth } from '../../contexts/AuthContext';
import { useError } from '../../contexts/ErrorContext';

export default function EditEntryModal({ entry, onClose, onSuccess }) {
  const { user } = useAuth();
  const { showError } = useError();
  const { execute, loading } = useApi(editLedgerEntry);
  
  const [amount, setAmount] = useState(Math.abs(entry.amount).toString());
  const [note, setNote] = useState(entry.note || '');
  const [type, setType] = useState(entry.amount >= 0 ? 'add' : 'subtract');

  const handleCurrencyChange = (value) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (value === '' || regex.test(value)) {
      setAmount(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount) || numAmount < 0) return showError("Please enter a valid amount");
    
    const finalAmount = type === 'subtract' ? -Math.abs(numAmount) : Math.abs(numAmount);
    await execute(entry.id, user.id, finalAmount, note.trim());
    onSuccess();
    onClose();
  };

  return (
    <Modal title="Edit Transaction" onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-amber-50 p-3 rounded-lg text-xs text-amber-800 mb-4 border border-amber-100">
          <strong>Note:</strong> Editing updates the balance and saves history.
        </div>
        
        <div className="grid grid-cols-2 gap-3 mb-2">
          <button 
            type="button" 
            onClick={() => setType('add')} 
            className={`p-2 rounded-lg border-2 text-sm font-bold ${type === 'add' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-200 text-gray-500'}`}
          >
            Add
          </button>
          <button 
            type="button" 
            onClick={() => setType('subtract')} 
            className={`p-2 rounded-lg border-2 text-sm font-bold ${type === 'subtract' ? 'border-red-500 bg-red-50 text-red-700' : 'border-gray-200 text-gray-500'}`}
          >
            Deduct
          </button>
        </div>

        <Input 
          label="New Amount ($)" 
          type="text"
          inputMode="decimal"
          value={amount} 
          onChange={e => handleCurrencyChange(e.target.value)} 
        />
        
        <Input 
          label="New Note" 
          value={note} 
          onChange={e => setNote(e.target.value)} 
        />

        <div className="flex justify-end space-x-3 pt-4">
          <Button variant="ghost" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" loading={loading} icon="Save">Save</Button>
        </div>
      </form>
    </Modal>
  );
}